import React from "react";
import { Link } from "react-router-dom";

export default function ContactMenu(props) {
  return (
    <div className="flex w-full bg-[#f4f4f4] rounded-[8px] overflow-hidden">
      <Link to={`/${props.lang}/about-us`} className="flex-1">
        <div className={`flex justify-center items-center py-[25px] cursor-pointer transition-colors hover:bg-gray-200`}>
          <h1 className={`text-subheading ${props.isOpen === 1 ? "text-[#FF4713] font-bold" : "text-[#4a4f54] font-medium"}`}>
            {props.lang === "th" ? "เกี่ยวกับเรา" : "About Us"}
          </h1>
        </div>
      </Link>

      <Link to={`/${props.lang}/staff`} className="flex-1">
        <div className={`flex justify-center items-center py-[25px] cursor-pointer transition-colors hover:bg-gray-200`}>
          <h1 className={`text-subheading ${props.isOpen === 2 ? "text-[#FF4713] font-bold" : "text-[#4a4f54] font-medium"}`}>
            {props.lang === "th" ? "บุคลากร" : "Staff"}
          </h1>
        </div>
      </Link>

      <Link to={`/${props.lang}/contact-us`} className="flex-1">
        <div className={`flex justify-center items-center py-[25px] cursor-pointer transition-colors hover:bg-gray-200`}>
          <h1 className={`text-subheading ${props.isOpen === 3 ? "text-[#FF4713] font-bold" : "text-[#4a4f54] font-medium"}`}>
            {props.lang === "th" ? "ติดต่อเรา" : "Contact Us"}
          </h1>
        </div>
      </Link>
    </div>
  );
}
